import React from "react"
import { Grid, makeStyles, CardContent, Card } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    text: {
        fontWeight: "bold",
    },
    card: {
        boxShadow: "none",
        width: "100%",
        backgroundColor: "#F8F8F8"
    }
}))

interface StudentDetailUpcomingCoursesItemProps {
    courseName: string;
    date?: string;
}

const StudentDetailUpcomingCoursesItem = ({ courseName, date }: StudentDetailUpcomingCoursesItemProps) => {
    const classes = useStyles()

    return (
        <div>
            <Grid style={{ marginBottom: "20px" }} container>
                <Card className={classes.card}>
                    <CardContent>
                        <Grid container justify="flex-start" alignItems="center">
                            <Grid item xs={8}>
                                <p className={classes.text}>Cursus</p>
                            </Grid>
                            <Grid item xs={4}>
                                <p>{courseName}</p>
                            </Grid>
                            <Grid item xs={8}>
                                <p className={classes.text}>Cursus datum</p>
                            </Grid>
                            <Grid item xs={4}>
                                <p>{date}</p>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </div>
    )
}

export default StudentDetailUpcomingCoursesItem
